import React, { FunctionComponent, useEffect } from 'react'
import { reactular } from '@vendhq/reactular'
import { useRegisterManager } from '../ng-compat/hooks'
import { OpenRegister } from '../components/register/OpenRegister'
import { CloseRegister } from '../components/register/CloseRegister'

export const RegisterOpenClose: FunctionComponent = () => {
  const registerManager = useRegisterManager()
  const [isOpen, setIsOpen] = React.useState(
    registerManager.isActiveRegisterOpen()
  )

  useEffect(() => {
    const updateIsOpen = () => {
      setIsOpen(registerManager.isActiveRegisterOpen())
    }

    registerManager.on('activeOutletChange', updateIsOpen)
    registerManager.on('activeRegisterChange', updateIsOpen)
    registerManager.on('activeRegisterClose', updateIsOpen)
    registerManager.on('activeRegisterOpen', updateIsOpen)
    registerManager.on('registerIdChange', updateIsOpen)

    return () => {
      registerManager.off('activeOutletChange', updateIsOpen)
      registerManager.off('activeRegisterChange', updateIsOpen)
      registerManager.off('activeRegisterClose', updateIsOpen)
      registerManager.off('activeRegisterOpen', updateIsOpen)
      registerManager.off('registerIdChange', updateIsOpen)
    }
  }, [registerManager])

  if (isOpen) {
    return <CloseRegister />
  }

  return <OpenRegister />
}

export const ReactRegisterOpenCloseComponent = reactular(
  RegisterOpenClose,
  [],
  'reactWrapper'
)
